<template>
    <div @click="cardClicked()" class="card card__event">
        <span class="session_opened" v-if="sellingSession">
            Session ouverte le {{ GlobalHelpers.formatDate(sellingSession.createdAt) }}
        </span>
        <div class="top">
            <h3 class="card--title">{{ event.name }}</h3>
        </div>
        <div class="bottom" v-if="event.dates.type == 'interval'">
            <div class="dates" :class="{'with-end-date': (dateEnd)}">
                <div v-if="dateStart" class="start_date date">
                    <span class="day">{{ dateStart.date }}</span>
                    <span class="hour">{{ dateStart.hour }}</span>
                </div>
                <div v-if="dateEnd" class="end_date date">
                    <span class="day">{{ dateEnd.date }}</span>
                    <span class="hour">{{ dateEnd.hour }}</span>
                </div>
            </div>
        </div>
        <div class="bottom sessions" v-else>
            Evénement contenant plusieurs sessions
        </div>
    </div>
</template>
<script setup lang="ts">
    import { GlobalHelpers } from "@/helpers/global.helper";
    import { Event } from "@/interfaces/Event";
    import { SellingSession } from "@/interfaces/SellingSession";
    import { computed } from "vue";
    const emit = defineEmits(['clicked'])

    interface Props {
        event: Event
        sellingSession?: SellingSession
    }

    const props = withDefaults(defineProps<Props>(), {})

    /*
    const props = defineProps({
        event: {type: Object, required: true},
        sellingSession: {type: Object, required: false},
    })*/

    const dateStart = computed(() => {
        if (props.event.dates.startDate) {
            const date = new Date(props.event.dates.startDate)
            return {
                'date': date.toLocaleDateString('fr', { day: "numeric", month: "short", year: "numeric" }),
                'hour': date.toLocaleTimeString('fr', {hour:"numeric", "minute":"numeric"})
            }
        }
        return null
    })

    const dateEnd = computed(() => {
        if (props.event.dates.endDate) {
            const date = new Date(props.event.dates.endDate)
            return {
                'date': date.toLocaleDateString('fr', { day: "numeric", month: "short", year: "numeric" }),
                'hour': date.toLocaleTimeString('fr', {hour:"numeric", "minute":"numeric"})
            }
        }
        return null
    })

    const cardClicked = () => {
        emit('clicked', props.event, props.sellingSession);
    }
</script>